module.exports = __webpack_public_path__ + "static/media/ultramalejpg.1743c4f4.png";